exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.myModal .el-drawer__body {\n  padding: 1.3em;\n}\n.myModal .el-drawer.ttb {\n  border-bottom-left-radius: 1em;\n  border-bottom-right-radius: 1em;\n}\n.myModal .el-drawer.ttb .el-drawer__body {\n  padding: 1.2em;\n}\n", ""]);

// exports
